module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.containerClass,
    attrs: {
      "aria-haspopup": "listbox",
      "aria-owns": _vm.listId,
      "aria-expanded": _vm.overlayVisible
    }
  }, [(!_vm.multiple) ? _c('input', _vm._g(_vm._b({
    ref: "input",
    class: _vm.inputClass,
    attrs: {
      "type": "text",
      "autoComplete": "off",
      "role": "searchbox",
      "aria-autocomplete": "list",
      "aria-controls": _vm.listId,
      "aria-labelledby": _vm.ariaLabelledBy
    },
    domProps: {
      "value": _vm.inputValue
    }
  }, 'input', _vm.$attrs, false), _vm.listeners)) : _vm._e(), _vm._v(" "), (_vm.multiple) ? _c('ul', {
    ref: "multiContainer",
    class: _vm.multiContainerClass,
    on: {
      "click": _vm.onMultiContainerClick
    }
  }, [_vm._l((_vm.value), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "p-autocomplete-token"
    }, [_c('span', {
      staticClass: "p-autocomplete-token-label"
    }, [_vm._v(_vm._s(_vm.getItemContent(item)))]), _vm._v(" "), _c('span', {
      staticClass: "p-autocomplete-token-icon pi pi-times-circle",
      on: {
        "click": function($event) {
          return _vm.removeItem($event, i)
        }
      }
    })])
  }), _vm._v(" "), _c('li', {
    staticClass: "p-autocomplete-input-token"
  }, [_c('input', _vm._g(_vm._b({
    ref: "input",
    attrs: {
      "type": "text",
      "autoComplete": "off",
      "role": "searchbox",
      "aria-autocomplete": "list",
      "aria-controls": _vm.listId,
      "aria-labelledby": _vm.ariaLabelledBy
    }
  }, 'input', _vm.$attrs, false), _vm.listeners))])], 2) : _vm._e(), _vm._v(" "), (_vm.searching) ? _c('i', {
    staticClass: "p-autocomplete-loader pi pi-spinner pi-spin"
  }) : _vm._e(), _vm._v(" "), (_vm.dropdown) ? _c('Button', {
    ref: "dropdownButton",
    staticClass: "p-autocomplete-dropdown",
    attrs: {
      "type": "button",
      "icon": "pi pi-chevron-down",
      "disabled": _vm.$attrs.disabled
    },
    on: {
      "click": _vm.onDropdownClick
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "p-connected-overlay"
    },
    on: {
      "enter": _vm.onOverlayEnter,
      "leave": _vm.onOverlayLeave
    }
  }, [(_vm.overlayVisible) ? _c('div', {
    ref: "overlay",
    staticClass: "p-autocomplete-panel p-component",
    style: ({
      'max-height': _vm.scrollHeight
    })
  }, [_c('ul', {
    staticClass: "p-autocomplete-items",
    attrs: {
      "id": _vm.listId,
      "role": "listbox"
    }
  }, _vm._l((_vm.suggestions), function(item, i) {
    return _c('li', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple"
      }],
      key: i,
      staticClass: "p-autocomplete-item",
      attrs: {
        "role": "option"
      },
      on: {
        "click": function($event) {
          return _vm.selectItem($event, item)
        }
      }
    }, [_vm._t("item", function() {
      return [_vm._v("\n                        " + _vm._s(_vm.getItemContent(item)) + "\n                    ")]
    }, {
      "item": item,
      "index": i
    })], 2)
  }), 0)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ab9586d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/autocomplete/AutoComplete.vue
// module id = 2288
// module chunks = 0